import type {WorkloadScore} from "../../4-scoring/performScoring.ts";
import type {Workload} from "../../3-workload-analysis/model/Workload.ts";
import type {WorkloadInput} from "../../3-workload-analysis/model/WorkloadInput.ts";
import {sortByScoreAndExecution} from "../utils/workloadSorting.ts";
import {RecommendationsList} from "../components/RecommendationsList.tsx";

/**
 * Section showing recommended workloads to migrate first
 */
export function RecommendationsSection({
    workloadScores,
    getWorkloadInput
}: {
    workloadScores: WorkloadScore[]
    getWorkloadInput: (workload: Workload) => WorkloadInput | undefined
}) {
    const recommendedWorkloads = sortByScoreAndExecution(workloadScores, 10)
    
    return (
        <section style={{marginTop: '2rem'}}>
            <h3>Where should I start?</h3>
            <p>
                We've looked at estimated complexity and combined with the most executed pipelines above - we 
                recommend starting here but of course it is up to you:
            </p>
            <RecommendationsList workloadScores={recommendedWorkloads} getWorkloadInput={getWorkloadInput} />
        </section>
    )
}
